import {
  apiRequest,
  skpBaruList,
  exportExcel,
  masterWorkUnit,
  skpBaruDetail,
} from "../../../../../services/adapters/kepegawaian/skpBaruService";

class DataTableRepository {
  fetchDetail = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      skpBaruDetail,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      skpBaruList,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchWorkUnit = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      masterWorkUnit,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };


  fetchExport = async (query) => {
    return await apiRequest(
      "get",
      exportExcel,
      {
        params: query,
      },
      true
    );
  };
}
export default DataTableRepository;
